<template>
  <div class="col-11 pl-0 ml-0">
    <v-row>
      <v-col class="pb-0">
        <p class="title pl-0 ml-0 mb-0 mt-5 mb-3">결제 하기</p>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="col-4 pt-0 pb-0">
        <v-select
          v-model="periodSelected"
          :items="periodList"
          outlined
          dense
        ></v-select>
      </v-col>
      <v-col class="row pt-0 pb-0 text-center">
        <v-btn large color="primary" width="200" @click.prevent="execOrder"
          >결제하기</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  data() {
    return {
      M,
      periodSelected: {
        text: "개월 수 선택",
        value: { sellPrice: 0, month: 0 },
      },
      periodList: [
        {
          text: "개월 수 선택",
          value: { sellPrice: 0, month: 0 },
        },
        {
          text: "1개월 : 33,000원",
          value: { sellPrice: 33000, month: 1 },
        },
        {
          text: "3개월 5% 할인 : 94,050원",
          value: { sellPrice: 94050, month: 3 },
        },
        {
          text: "6개월 7% 할인 : 184,140원",
          value: { sellPrice: 184140, month: 6 },
        },
        {
          text: "12개월 10% 할인 : 356,400원",
          value: { sellPrice: 356400, month: 12 },
        },
      ],
    };
  },

  mixins: [CommonMixin],
  methods: {
    execOrder: async function() {
      let today = new Date();
      let year = today.getFullYear();
      let month = today.getMonth() + 1;
      let date = today.getDate();

      let todayDate = year + "-" + month + "-" + date;

      let afterday = new Date();
      afterday.setMonth(today.getMonth() + this.periodSelected.month);

      let afterYear = afterday.getFullYear();
      let afterMonth = afterday.getMonth() + 1;
      let afterDate = afterday.getDate();

      let afterdayDate = afterYear + "-" + afterMonth + "-" + afterDate;

      if (this.periodSelected.month > 0 && this.periodSelected.sellPrice > 0) {
        let params = {
          month: this.periodSelected.month,
          sellPrice: this.periodSelected.sellPrice,
          startDate: todayDate,
          endDate: afterdayDate,
        };

        await M.api(M.entry("/api/cert/partners/paymnet"), params);
      } else {
        this.alertShow("결제 내용을 선택해주세요.");
      }
    },
  },
};
</script>
